export const DOCUMENT_VERIFICATION_STATES = {
  COMPLETED: "Completada",
  PENDING: "Pendiente",
};
